export default "__VITE_ASSET__16102289__"